import { createContext } from 'react';
import { useThemeConfig } from '../hooks/useThemeConfig';
import { lightTheme } from '../theme/themes';

export const ThemeContext = createContext({
  theme: {
    ...lightTheme,
    colors: { ...lightTheme.colors, primary: '#007bff' },
  },
  themeSchema: 'light',
  handleTheme: () => {},
  handlePrimaryColor: () => {},
});

export function CustomThemeProvider({ children }) {
  const { theme, themeSchema, handleTheme, handlePrimaryColor } =
    useThemeConfig();
  return (
    <ThemeContext.Provider
      value={{
        theme,
        themeSchema,
        handleTheme,
        handlePrimaryColor,
      }}
    >
      {children}
    </ThemeContext.Provider>
  );
}
